import { Box } from '@chakra-ui/react';

import React from 'react';
import { getChatEntityColor } from '../entityStyles';
import { RenderElementPropsFor } from '@texas/extensions';
import { EntityCategoryElement } from '../extensions';
import { ensureEnumKey } from '@texas/utils/helpers/enumHelpers';
import { ChatMessageEntityLinkType } from '@texas/api/endpoints/chat/chatApi';

export function EntityCategory({
  children,
  attributes,
  element,
}: RenderElementPropsFor<EntityCategoryElement>) {
  return (
    <Box
      {...attributes}
      as="span"
      background={getChatEntityColor(element.entityType)}
      fontWeight="bold"
      display="inline-block"
      borderRadius="sm"
      padding="2px 4px"
      fontSize="0.9em"
      color="white"
    >
      <div contentEditable={false}>
        <React.Fragment>
          @{ensureEnumKey(ChatMessageEntityLinkType, element.entityType)}
          {children}
        </React.Fragment>
      </div>
    </Box>
  );
}
